module.exports = __webpack_public_path__ + "static/media/dashboard.18d506cc.svg";